import { Injectable } from '@angular/core';
import _ from 'lodash';
import FifoArray from 'fifo-array';
import { PageService } from './page.service';
import { Page } from '../models/page';
import { ApplicationStateService } from './application-state.service';

@Injectable({
    providedIn: 'root'
})
export class PreloadService {

    private static PRELOAD_TIMEOUT = 1000;
    private static MAX_STORED_IMGS = 10;

    preloadPages: (() => void) & _.Cancelable;

    private preloadedPages: Array<Page> = [];
    private images;

    constructor(private applicationStateService: ApplicationStateService,
                private pageService: PageService) {

        this.images = new FifoArray({ max: PreloadService.MAX_STORED_IMGS });
        this.preloadPages = _.debounce(this.preloadPagesCallback, PreloadService.PRELOAD_TIMEOUT);
    }

    /**
     * Preloads the next images based on the current active page and the current ViewMode.
     */
    private preloadPagesCallback(): void {

        const currentIndex = this.applicationStateService.currentIndex;
        const pages = this.pageService.getPages(currentIndex, currentIndex + this.applicationStateService.currentViewMode.imagesToPreload);
        const images = [];
        pages.forEach(page => {

            if (_.isEmpty(_.find(this.preloadedPages, { id: page.id }))) {
                this.preloadedPages.push(page);
                images.push(page.image.url);
                // images.push(page.zoomImage.url);
            }
        });
        this.preloadImages(images);
    }

    // IMPORTANT: DO NOT REMOVE! Might be needed.
    /*preloadThumbnails() {

        this.pageService.getAllPages()
            .then(pages => {

                    let images = [];
                    pages.forEach(page => {
                        images.push(page.thumbnailImage.url);
                    });
                    this.preloadImages(images);
                }
            );
    }
    */

    /**
     * Loads the images.
     * @param images An Array of image URLs to preload.
     */
    private preloadImages(images: Array<string>): void {

        images.forEach(ele => {
            const image = new Image();
            image.src = ele;
            this.images.push(image);
        });
    }

}
